import React, { useEffect, useState } from 'react'
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useDevice } from '../contexts/DevicesContext';
import { useAuth } from '../contexts/AuthContext';
import { deviceNav } from '../components/NavigationPath';
import PageHeader from '../components/PageHeader';
import AddDevice from '../components/AddDevice';
import Layout2 from '../components/Layout2';
import Loader from '../components/Loader';

function DeviceList() {
    const { getAllDevices, deleteDevice } = useDevice()
    const { restaurantId } = useAuth();

    const [deviceList, setDeviceList] = useState()
    const [sortField, setSortField] = useState('createdAt');
    const [sortOrder, setSortOrder] = useState(-1);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [deviceVisible, setDeviceVisible] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editDeviceId, setEditDeviceId] = useState(null);

    const fetchDevices = async () => {
        try {
            setIsLoading(true);
            const devices = await getAllDevices(currentPage, rowsPerPage, sortField, sortOrder);
            if (devices.length !== 0) {
                setDeviceList(devices.data)
                setTotalRecords(devices.totalCount)
            }
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching roles', error);
        }
    };

    useEffect(() => {
        if (restaurantId) {
            fetchDevices();
        }
    }, [currentPage, rowsPerPage, sortField, sortOrder, restaurantId]);

    const handleSorting = async (e) => {
        const field = e.sortField;
        const order = e.sortOrder;

        setSortField(field);
        setSortOrder(order);
        fetchDevices()
    };

    const onPageChange = (event) => {
        const newCurrentPage = Math.floor(event.first / event.rows) + 1;
        setCurrentPage(newCurrentPage);
        const newRowsPerPage = event.rows;
        setRowsPerPage(newRowsPerPage);
    };

    const handleDelete = async (deviceId) => {
        try {
            const confirmed = await confirmDelete();

            if (confirmed) {
                await deleteDevice(deviceId);
                fetchDevices();
            }
        } catch (error) {
            console.error('Error during delete operation', error);
        }
    }

    const confirmDelete = async () => {
        return new Promise((resolve) => {
            confirmDialog({
                message: 'Are you sure you want to delete this device?',
                header: 'Delete Confirmation',
                icon: 'pi pi-info-circle',
                position: 'top',
                accept: () => resolve(true),
                reject: () => resolve(false),
            });
        });
    };

    const handleUpdate = async (deviceId) => {
        setEditDeviceId(deviceId);
        setEditMode(true);
        setDeviceVisible(false);
    }

    return (
        <Layout2 items={deviceNav.items} navTitle={deviceNav.header}>
            <div className="d-flex flex-column w-100">
                <PageHeader
                    title={'Devices'}
                    buttonLable={'Add New Device'}
                    buttonOnClick={() => setDeviceVisible(true)}
                />
                <div className='px-4 py-2'>
                    <ConfirmDialog />
                    {(deviceVisible || (editMode && editDeviceId)) && (
                        <AddDevice
                            editMode={editMode}
                            editDeviceId={editDeviceId}
                            setEditDeviceId={setEditDeviceId}
                            setEditMode={setEditMode}
                            deviceVisible={deviceVisible}
                            setDeviceVisible={setDeviceVisible}
                            fetchDevices={fetchDevices}
                        />
                    )}
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <DataTable
                            className="customerTable thead-dark"
                            totalRecords={totalRecords}
                            lazy
                            paginator
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={(e) => {
                                if (!e.sortField && e.sortOrder === 0) {
                                    handleSorting({ sortField: 'createdAt', sortOrder: -1 });
                                } else {
                                    handleSorting(e);
                                }
                            }}
                            removableSort
                            rows={rowsPerPage}
                            value={deviceList}
                            first={(currentPage - 1) * rowsPerPage}
                            onPage={onPageChange}
                            dataKey="id"
                            emptyMessage="No devices found."
                        >
                            <Column
                                field="name"
                                header="Name"
                                sortable
                                filterField="name"
                            />
                            <Column
                                field="version"
                                header="Version"
                                sortable
                                filterField="version"
                            />
                            <Column
                                header="Action"
                                className='action_td'
                                align="left"
                                body={(rowData) => (
                                    <>
                                        <i className="pi pi-pencil pointerCursor" title='Edit' onClick={() => handleUpdate(rowData.id)} />
                                        <i className="pi pi-trash ms-2 pointerCursor" title='Delete' aria-label="Cancel" onClick={() => handleDelete(rowData.id)} />
                                    </>
                                )}
                            />
                        </DataTable>
                    )}
                </div>
            </div>
        </Layout2>
    )
}

export default DeviceList